import { Card, ModernCardHeader } from "../../../components/cards";
import { useMe } from "../../users/hooks/useMe";
import { Activity, UsersIcon } from "lucide-react";
import { useSites } from "../../sites/hooks";
import { SiteCard, SitesInfos } from "../../sites/components";
import { ProductsInfos } from "../../products/components";
import { ReferencesInfos } from "../../references/components";
import { ScansInfos } from "../../scans/components";
import { SentinelsInfos } from "../../sentinels/components";
import { UsersInfos } from "../../users/components";
import { FavoritesDashboardCard } from "../../favorites/components";

export const Customer = () => {
  const { data } = useMe();
  const { data: sitesData } = useSites({ where: {} });

  return (
    <div className="space-y-4 p-2">
      {/* Welcome Banner */}
      <Card
        padding="md"
        className="bg-gradient-to-r from-primary-600 to-primary-700 border-0 text-white"
      >
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center backdrop-blur-sm">
            <Activity className="w-6 h-6 text-white" />
          </div>
          <div>
            <h2 className="text-lg font-bold mb-1">
              Bienvenue, {data?.me?.firstname || "Admin"}
            </h2>
            <p className="text-sm text-white/90">
              Gérez votre plateforme de supervision et suivez vos performances
            </p>
          </div>
        </div>
      </Card>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <SitesInfos />
        <ProductsInfos />
        <ReferencesInfos />
        <ScansInfos />
      </div>

      {/* Sites Récents */}
      <Card>
        <ModernCardHeader
          title="Cibles Récentes"
          subtitle="Vos derniers sites configurés"
        />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-4">
          {(sitesData?.sites?.results?.length || 0) > 0 ? (
            sitesData?.sites?.results
              ?.slice(0, 4)
              .map((site) => (
                <SiteCard
                  key={site?.id}
                  id={site?.id}
                  name={site?.name}
                  url={site?.url}
                  productsCount={site?.productsCount}
                />
              ))
          ) : (
            <div className="col-span-full text-center py-8 text-gray-500 text-sm">
              Aucun site configuré
            </div>
          )}
        </div>
        {sitesData?.sites?.results && sitesData.sites.results.length > 0 && (
          <div className="mt-4 text-center">
            <a
              href="/sites"
              className="text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors"
            >
              Voir tous les sites →
            </a>
          </div>
        )}
      </Card>

      <FavoritesDashboardCard />
    </div>
  );
};
